import React, { FC, useCallback, useEffect, useState } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { AreenaTopicModal } from '../components/AreenaTopicModal/AreenaTopicModal'
import { routes } from '../constants/routes'
import { Navigation } from '../components/Navigation/Navigation'
import { useNavigate } from 'react-router'
import { useLogin } from '../providers/LoginProvider'
import { useModerationState } from '../providers/ModerationStateProvider'
import { Topic } from '../models/topic'
import { isOperator } from '../utils/user'
import { TopicList } from '../components/Topic/TopicList'
import { maxWidth } from '../utils/mediaQuery'
import { RoleGuard } from '../components/RoleGuard/RoleGuard'

export const DiscussionsPage: FC = () => {
  const isMobile = useMediaQuery(maxWidth('lg'))
  const navigate = useNavigate()
  const { user } = useLogin()
  const {
    topicsAndComments: { topics, selectedTopic, topicFilter, setTopicFilter }
  } = useModerationState()
  const [isAreenaTopicModalOpen, setIsAreenaTopicModalOpen] = useState(false)
  const [editedAreenaTopic, setEditedAreenaTopic] = useState<Topic>()

  const onSelectTopic = useCallback(
    (topicId?: string) => {
      navigate(`${routes.moderation}/${topicId}`)
    },
    [navigate]
  )

  useEffect(() => {
    // In desktop, skip showing DicsussionsPage to the user and just navigate to ModerationPage upon arrival
    if (!isMobile) {
      const topicId = selectedTopic?.id || topics[0]?.id
      if (topicId) {
        navigate(`${routes.moderation}/${topicId}`)
      }
    }
  }, [isMobile, selectedTopic, navigate, topics])

  return (
    <Navigation currentRoute="moderation">
      <RoleGuard allowedRoles={['moderator', 'operator', 'commentator']}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            flex: 1,
            maxWidth: { md: '100%', lg: '563px' }
          }}
        >
          <TopicList
            topics={topics}
            topicFilter={topicFilter}
            setTopicFilter={setTopicFilter}
            selectedTopic={undefined}
            setSelectedTopic={onSelectTopic}
            openAreenaTopicModal={
              isOperator(user) ? () => setIsAreenaTopicModalOpen(true) : undefined
            }
          />
        </Box>
        <AreenaTopicModal
          open={isAreenaTopicModalOpen}
          topic={editedAreenaTopic}
          handleClose={() => {
            setEditedAreenaTopic(undefined)
            setIsAreenaTopicModalOpen(false)
          }}
          navigate={navigate}
        />
      </RoleGuard>
    </Navigation>
  )
}
